import SearchSVG from "../../../assets/Icons/SearchInput";

const SerachInput = () => {
  return (
    <div>
      <div className="relative">
        <form
          // onSubmit={(e) => handleSubmit(e)}
          className="flex items-center justify-start md:pt-0"
          autoComplete="off"
        >
          <div className="relative flex h-10 w-[350px]">
            <input
              type="search"
              id="default-search"
              className="block w-full gap-4 rounded-md border border-gray-300 p-4 text-sm text-gray-900 ring-black hover:ring-1 focus:ring-1"
              placeholder={"Search"}
              // value={value}
              // onChange={onChangeInput}
              // onFocus={handleInputFocus}
              required
            />
            <button type="submit" className="absolute bottom-5 right-12 cursor-pointer">
              <div className="absolute inset-y-0 start-0 flex items-center ps-3">
                <SearchSVG stroke={"black"} />
              </div>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SerachInput;
